import React from 'react';
import { Growl } from 'primereact/growl';
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import Moment from 'react-moment';
import { Dropdown } from 'primereact/dropdown';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioUsuario from '../servicios/ServicioUsuario';
import servicioArchivos from '../servicios/ServicioArchivos';
import servicioCfdi from '../servicios/ServicioCfdi';
import servicioFormatos from '../servicios/ServicioFormatos';
import servicioSerie from '../servicios/ServicioSerie';
import servicioFacturacionEmergencia from '../servicios/ServicioFacturacionEmergencia';
import servicioTickets from '../servicios/ServicioTicket';
import servicioEmisor from '../servicios/ServicioEmisor';
import servicioIdioma from '../servicios/ServicioIdiomaFecha';
import servicioMaterial from '../servicios/ServicioMaterial';

export class ConsultaReportes extends React.Component {

  constructor() {
    super();
    this.state = {
      rfcEmisor: '',
      paginacion: {
        registrosPorPagina: 20,
        datos: []
      },
      inicio: 0,
      usuario: {},
      activeIndex: null,
      activeFacturacionIndex: null,
      erroresUsuarios: {},
      excelUsuarios: false,
      excelFacturacionUsuario: false,
      excelFacturacionDiaria: false,
      excelFacturacionSerieFecha: false,
      excelFacturacionMes: false,
      cfdi: {},
      erroresUsuario: {},
      listaSeries: [],
      plazasCobro: [],
      plazaCobro: {},
      ticket: { tcCarril: {} },
      listaAforos: [],
      listaMateriales: [],
      restriccionSesion: []
    }
  }

  componentDidMount() {
    this.buscar_emisor_asignado_usuario();
  }

  buscar_emisor_asignado_usuario = () => {
    servicioEmisor.buscar_emisor_asignado_usuario().then(response => {
      if (response.data.error)
        this.setState({ rfcEmisor: response.data.mensaje });
      else
        this.setState({ rfcEmisor: response.data.mensaje });
    });
  }

  asignarValoresObjeto = (event) => {
    if (event.target.name === "usuario.usuario")
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    else
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
  }

  buscar_usuarios_estado = () => {
    let { usuario, paginacion } = this.state;
    let erorres = this.validar_formulario_usuarios(usuario);
    this.setState({ erroresUsuarios: erorres });
    if (!Object.keys(erorres).length) {
      paginacion['restriccionesDinamicas'] = [{
        tipoRestriccion: "eq", nombrePropiedad: "estado",
        valorPropiedad: usuario.estado
      }];
      this.setState({ paginacion: paginacion, restriccionSesion: paginacion.restriccionesDinamicas });
      setTimeout(() => {
        this.obtener_pagina();
      }, 0);
    }

  };

  descargar_excel_usuario = () => {
    let { usuario } = this.state;
    servicioArchivos.descargaArchivo("reportes/descargar_reporte_usuarios.json", usuario);
  }

  descargar_excel_facturacion_usuario = () => {
    let { usuario, cfdi } = this.state;
    let fechaIncial = cfdi.fechaCreacion.getTime();
    let fechaFinal = cfdi.fechaCertificacion.getTime();
    let cfdiObj = { fechaCreacion: fechaIncial, fechaCertificacion: fechaFinal };
    servicioArchivos.descargaArchivo("reportes/descargar_reporte_facturacion_usuario.json", { ttUsuario: usuario, ttCfdi: cfdiObj });
  }

  descargar_excel_facturacion_diaria = () => {
    let { cfdi } = this.state;
    let fechaIncial = cfdi.fechaCreacion.getTime();
    let fechaFinal = cfdi.fechaCertificacion.getTime();
    let cfdiObj = { fechaCreacion: fechaIncial, fechaCertificacion: fechaFinal };
    servicioArchivos.descargaArchivo("reportes/descargar_reporte_facturacion_diaria.json", { ttCfdi: cfdiObj });
  }

  descargar_excel_facturacion_serie_fecha = () => {
    let { cfdi } = this.state;
    let fechaIncial = cfdi.fechaCreacion.getTime();
    let fechaFinal = cfdi.fechaCertificacion.getTime();
    let cfdiObj = { fechaCreacion: fechaIncial, fechaCertificacion: fechaFinal, serie: cfdi.serie.nombre };
    servicioArchivos.descargaArchivo("reportes/descargar_reporte_facturacion_serie_fecha.json", { ttCfdi: cfdiObj });
  }

  descargar_excel_facturacion_mes = () => {
    servicioArchivos.descargaArchivo("reportes/descargar_reporte_facturacion_mes.json", null);
  }

  descargar_excel_facturacion_rfc_receptor = () => {
    let { cfdi } = this.state;
    let fechaIncial = cfdi.fechaCreacion.getTime();
    let fechaFinal = cfdi.fechaCertificacion.getTime();
    let cfdiObj = { fechaCreacion: fechaIncial, fechaCertificacion: fechaFinal };

    servicioArchivos.descargaArchivo("reportes/descargar_reporte_facturacion_rfc_receptor.json", { ttCfdi: cfdiObj, tcReceptor: { rfc: cfdi.rfcReceptor } });
  }

  descargar_excel_facturacion_tipo_factura = () => {
    let { cfdi } = this.state;
    let fechaIncial = cfdi.fechaCreacion.getTime();
    let fechaFinal = cfdi.fechaCertificacion.getTime();
    let cfdiObj = { fechaCreacion: fechaIncial, fechaCertificacion: fechaFinal, tipoFactura: cfdi.tipoFactura.code };

    servicioArchivos.descargaArchivo("reportes/descargar_reporte_facturacion_tipo_factura.json", { ttCfdi: cfdiObj });
  }

  descargar_excel_facturacion_total_aforo = () => {
    let { ticket } = this.state;
    var ticketEnvio = JSON.parse(JSON.stringify(ticket));
    let plazaCobro = ticketEnvio.tcCarril;
    delete ticketEnvio['tcCarril'];
    ticketEnvio.tcCarril = { tcPlazaCobro: plazaCobro };
    let fechaIncial = new Date(ticketEnvio.fechaFacturacion).getTime();
    ticketEnvio.fechaTicket = fechaIncial;
    servicioArchivos.descargaArchivo("reportes/descargar_reporte_facturacion_total_afores.json", ticketEnvio);
  }

  cambiar_pagina = (event) => {
    let { paginacion } = this.state;
    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    this.setState({ inicio: event.first, paginacion });
    this.obtener_pagina();
  }


  obtener_pagina() {
    let { paginacion, restriccionSesion } = this.state;
    console.log(restriccionSesion);
    if (!servicioAsignacionValoresObjetos.esObjetoVacio(restriccionSesion)) {
      paginacion.restriccionesDinamicas = restriccionSesion;
    }
    servicioUsuario.buscar_reportes(paginacion).then((response) => {
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
      this.setState({ paginacion: response.data.objeto });
      if (response.data.objeto.datos.length === 0)
        this.setState({ excelUsuarios: false });
      else
        this.setState({ excelUsuarios: true });
    })

  }

  tab_panel = (event) => {
    let { activeIndex } = this.state;
    activeIndex = event.index
    this.setState({ activeIndex });
    this.actualizar_valores();
    if (activeIndex === 2)
      this.buscar_plazas_cobro_asignadas();

  }

  buscar_materiales = () => {
    let paginacion = { registrosPorPagina: 500 };
    servicioMaterial.paginacion(paginacion).then(response => {
      if (response.data.objeto != null)
        this.setState({ listaMateriales: response.data.objeto.datos });
    });
  }
  tab_panel_facturacion = (event) => {
    let { activeFacturacionIndex } = this.state;
    activeFacturacionIndex = event.index;
    this.setState({ activeFacturacionIndex });
    this.actualizar_valores();

    if (activeFacturacionIndex === 2)
      this.series_emisor();
    if (activeFacturacionIndex === 5)
      this.buscar_materiales();

  }

  series_emisor = () => {
    servicioSerie.series_emisor().then(response => {
      this.setState({ listaSeries: response.data.lista });
    });
  }

  actualizar_valores = () => {
    this.setState({
      paginacion: {
        registrosPorPagina: 20,
        datos: []
      },
      inicio: 0,
      usuario: {},
      cfdi: {},
      erroresUsuario: {},
      restriccionSesion: []
    });
  }

  validar_formulario_usuarios = (usuario) => {
    const erroresRequeridos = {};
    if (!usuario.estado) {
      erroresRequeridos.estado = "El estatus es requerido";
    }
    return erroresRequeridos;
  }

  buscar_facturacion_usuario = () => {
    let { paginacion, cfdi, usuario } = this.state;
    let errores = this.validar_facturacion_usuario(usuario, cfdi);
    this.setState({ erroresUsuario: errores });
    if (!Object.keys(errores).length) {
      paginacion['restriccionesDinamicas'] = [{
        tipoRestriccion: "between", nombrePropiedad: "alias_ttCfdi.fechaCreacion",
        valorPropiedad: null, fechaIncialBetween: servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCreacion) + " 00:00:00",
        fechaFinalBetween: servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCertificacion) + " 23:59:59"
      },
      {
        tipoRestriccion: "eq", nombrePropiedad: "alias_ttUsuario.usuario",
        valorPropiedad: usuario.usuario
      }];
      this.setState({ paginacion: paginacion, restriccionSesion: paginacion.restriccionesDinamicas });
      setTimeout(() => {
        this.obtener_pagina_facturacion_usuarios();
      }, 0);
    }

  }

  buscar_facturacion_pordia = () => {
    let { paginacion, cfdi } = this.state;
    let errores = this.validar_formulario_pordia(cfdi);
    this.setState({ erroresUsuario: errores });
    if (!Object.keys(errores).length) {
      paginacion['restriccionesDinamicas'] = [{
        tipoRestriccion: "between", nombrePropiedad: "alias_ttCfdi.fechaCreacion",
        valorPropiedad: null, fechaIncialBetween: servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCreacion) + " 00:00:00",
        fechaFinalBetween: servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCertificacion) + " 23:59:59"
      }];
      this.setState({ paginacion: paginacion, restriccionSesion: paginacion.restriccionesDinamicas });
      setTimeout(() => {
        this.obtener_pagina_facturacion_usuarios();
      }, 0);
    }
  }

  buscar_facturacion_serie_fecha = (e) => {
    let { paginacion, cfdi } = this.state;
    let errores = this.validar_formulario_serie_fecha(cfdi);
    this.setState({ erroresUsuario: errores });
    if (servicioAsignacionValoresObjetos.esObjetoVacio(errores)) {
      paginacion['restriccionesDinamicas'] = [{
        tipoRestriccion: "between", nombrePropiedad: "alias_ttCfdi.fechaCreacion",
        valorPropiedad: null, fechaIncialBetween: servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCreacion) + " 00:00:00",
        fechaFinalBetween: servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCertificacion) + " 23:59:59"
      },
      {
        tipoRestriccion: "eq", nombrePropiedad: "alias_ttCfdi.serie",
        valorPropiedad: cfdi.serie.nombre
      }];
      this.setState({ paginacion, restriccionSesion: paginacion.restriccionesDinamicas });
      setTimeout(() => {
        this.obtener_pagina_facturacion_usuarios();
      }, 0);
    }
  }

  buscar_facturacion_mes = () => {
    let { paginacion } = this.state;
    var date = new Date();
    date.setMonth(date.getMonth() - 1);
    var primerDia = new Date(date.getFullYear(), date.getMonth(), 1);
    var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    paginacion['restriccionesDinamicas'] = [{
      tipoRestriccion: "between", nombrePropiedad: "alias_ttCfdi.fechaCreacion",
      valorPropiedad: null, fechaIncialBetween: servicioFormatos.formatearFechaStringSinSegundos(primerDia) + " 00:00:00",
      fechaFinalBetween: servicioFormatos.formatearFechaStringSinSegundos(ultimoDia) + " 23:59:59"
    },
    {
      tipoRestriccion: "eq", nombrePropiedad: "alias_ttCfdi.tipoComprobante",
      valorPropiedad: "E"
    }];
    this.setState({ paginacion: paginacion, restriccionSesion: paginacion.restriccionesDinamicas });
    setTimeout(() => {
      this.obtener_pagina_facturacion_usuarios();
    }, 0);
  }

  validar_formulario_serie_fecha = (cfdi) => {
    const erroresRequeridos = {};
    if (!cfdi.serie)
      erroresRequeridos.serie = "La serie es requerida";
    if (!cfdi.fechaCreacion)
      erroresRequeridos.fechaCreacion = "La fecha inicial es requerida";
    if (!cfdi.fechaCertificacion)
      erroresRequeridos.fechaCertificacion = "La fecha final es requerida";
    return erroresRequeridos;
  }

  validar_formulario_pordia = (cfdi) => {
    const erroresRequeridos = {};
    if (!cfdi.fechaCreacion)
      erroresRequeridos.fechaCreacion = "La fecha inicial es requerida";
    if (!cfdi.fechaCertificacion)
      erroresRequeridos.fechaCertificacion = "La fecha final es requerida";
    return erroresRequeridos;
  }

  obtener_pagina_facturacion_usuarios() {
    let { paginacion, restriccionSesion } = this.state;
    if (!servicioAsignacionValoresObjetos.esObjetoVacio(restriccionSesion)) {
      paginacion.restriccionesDinamicas = restriccionSesion;
    }
    servicioCfdi.paginacion_admin(paginacion).then((response) => {
      this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
      this.setState({ paginacion: response.data.objeto });

    })

  }

  cambiar_pagina_usuarios = (event) => {
    let { paginacion } = this.state;
    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    this.setState({ inicio: event.first, paginacion });
    this.obtener_pagina_facturacion_usuarios();
  }

  validar_facturacion_usuario = (usuario, cfdi) => {
    const erroresRequeridos = {};
    if (!usuario.usuario)
      erroresRequeridos.usuario = "El usuario es requerido";
    if (!cfdi.fechaCreacion)
      erroresRequeridos.fechaCreacion = "La fecha inicial es requerida";
    if (!cfdi.fechaCertificacion)
      erroresRequeridos.fechaCertificacion = "La fecha final es requerida";
    return erroresRequeridos;
  }

  columnaEstatus = (rowData, column) => {
    if (rowData.ttCfdi.estado === 1)
      return <p>Activo</p>
    if (rowData.ttCfdi.estado === 0)
      return <p>Cancelado</p>
  }

  columnaTipoFactura = (rowData, column) => {
    if (rowData.ttCfdi.tipoFactura === 0)
      return <p>Factura de pagos</p>
    if (rowData.ttCfdi.tipoFactura === 1)
      return <p>Factura de emergencia</p>
    if (rowData.ttCfdi.tipoFactura === 2)
      return <p>Factura de Peaje</p>
    if (rowData.ttCfdi.tipoFactura === 3)
      return <p>Factura reexpedida</p>
    if (rowData.ttCfdi.tipoFactura === 4)
      return <p>Ingresos diversos</p>
    if (rowData.ttCfdi.tipoFactura === 5)
      return <p>Ingresos diversos/Nota de crédito</p>
    if (rowData.ttCfdi.tipoFactura === 6)
      return <p>Nota de crédito</p>

  }

  columnaTipoComprobante = (rowData, column) => {
    if (rowData.ttCfdi.tipoComprobante === "I")
      return <p>Ingreso</p>
    if (rowData.ttCfdi.tipoComprobante === "E")
      return <p>Egreso</p>
    if (rowData.ttCfdi.tipoComprobante === "P")
      return <p>Pagos</p>
  }

  columnaTotal = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.ttCfdi.total)}</div>;
  }


  columnaFechaCreacion = (rowData, column) => {
    if (!rowData.ttCfdi.fechaCreacio) {
      return <Moment format="YYYY-MM-DD HH:mm:ss">
        {rowData.ttCfdi.fechaCreacion}
      </Moment>;
    }

  }


  buscar_plazas_cobro_asignadas = () => {
    servicioFacturacionEmergencia.plazas_asignadas_emisor().then(response => {
      if (response.data.error)
        this.growl.show({ life: 6000, severity: 'error', summary: 'error', detail: response.data.mensaje });
      else
        this.setState({ plazasCobro: response.data.lista });
    });
  }

  buscar_reporte_aforo = () => {
    let { ticket } = this.state;
    let errores = this.validar_formulario_aforo(ticket);
    this.setState({ erroresUsuario: errores });
    if (!Object.keys(errores).length) {
      var ticketEnvio = JSON.parse(JSON.stringify(ticket));
      let plazaCobro = ticketEnvio.tcCarril;
      delete ticketEnvio['tcCarril'];
      ticketEnvio.tcCarril = { tcPlazaCobro: plazaCobro };
      let fechaIncial = new Date(ticketEnvio.fechaFacturacion).getTime();
      ticketEnvio.fechaTicket = fechaIncial;
      servicioTickets.reporte_total_afores(ticketEnvio).then(response => {
        this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        this.setState({ listaAforos: response.data.lista });
      })
    }



  }

  validar_formulario_aforo = (ticket) => {
    const erroresRequeridos = {};
    if (!ticket.fechaFacturacion)
      erroresRequeridos.fechaFacturacion = "La fecha es requerida";
    if (!ticket.tcCarril.id)
      erroresRequeridos.tcCarril = "La plaza de cobro es requerida";

    return erroresRequeridos;
  }

  columnaFechaTickets = (rowData, column) => {
    return <Moment format="YYYY-MM-DD">
      {rowData.fechaFacturacion}
    </Moment>;
  }

  columnaSumaTickets = (rowData, column) => {
    return <div>{servicioFormatos.formatearModena(rowData.total)}</div>;
  }


  buscar_facturacion_rfc_receptor = () => {
    let { paginacion, cfdi } = this.state;
    let errores = this.validar_formulario_receptor(cfdi);
    this.setState({ erroresUsuario: errores });
    if (!Object.keys(errores).length) {
      paginacion['restriccionesDinamicas'] = [{
        tipoRestriccion: "between", nombrePropiedad: "alias_ttCfdi.fechaCreacion",
        valorPropiedad: null, fechaIncialBetween: servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCreacion) + " 00:00:00",
        fechaFinalBetween: servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCertificacion) + " 23:59:59"
      },
      {
        tipoRestriccion: "eq", nombrePropiedad: "alias_tcReceptor.rfc",
        valorPropiedad: cfdi.rfcReceptor
      }];
      this.setState({ paginacion, restriccionSesion: paginacion.restriccionesDinamicas });
      setTimeout(() => {
        this.obtener_pagina_facturacion_usuarios();
      }, 0);
    }

  }

  buscar_facturacion_ingresos_diversos = () => {
    let { paginacion, cfdi } = this.state;
    let errores = this.validar_formulario_ingresos_diversos(cfdi);
    this.setState({ erroresUsuario: errores });
    if (!Object.keys(errores).length) {
      paginacion['restriccionesDinamicas'] = [{
        tipoRestriccion: "eq", nombrePropiedad: "alias_tcMaterialeses.descripcion",
        valorPropiedad: cfdi.ingresodiverso.descripcion
      }];
      this.setState({ paginacion, restriccionSesion: paginacion.restriccionesDinamicas });
      setTimeout(() => {
        this.obtener_pagina_facturacion_usuarios();
      }, 0);
    }

  }

  validar_formulario_ingresos_diversos = (cfdi) => {
    const erroresRequeridos = {};
    if (!cfdi.ingresodiverso)
      erroresRequeridos.ingresodiverso = "El material es requerido";

    return erroresRequeridos;
  }

  validar_formulario_receptor = (cfdi) => {
    const erroresRequeridos = {};
    if (!cfdi.rfcReceptor)
      erroresRequeridos.rfcReceptor = "El rfc de receptor es requerido";
    if (!cfdi.fechaCreacion)
      erroresRequeridos.fechaCreacion = "La fecha inicial es requerida";
    if (!cfdi.fechaCertificacion)
      erroresRequeridos.fechaCertificacion = "La fecha final es requerida";
    return erroresRequeridos;
  }

  buscar_facturacion_tipo_factura = () => {
    let { paginacion, cfdi } = this.state;
    let errores = this.validar_formulario_tipo_factura(cfdi);
    this.setState({ erroresUsuario: errores });
    if (!Object.keys(errores).length) {
      paginacion['restriccionesDinamicas'] = [{
        tipoRestriccion: "between", nombrePropiedad: "alias_ttCfdi.fechaCreacion",
        valorPropiedad: null, fechaIncialBetween: servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCreacion) + " 00:00:00",
        fechaFinalBetween: servicioFormatos.formatearFechaStringSinSegundos(cfdi.fechaCertificacion) + " 23:59:59"
      },
      {
        tipoRestriccion: "eq", nombrePropiedad: "alias_ttCfdi.tipoFactura",
        valorPropiedad: cfdi.tipoFactura.code
      }];

      this.setState({ paginacion, restriccionSesion: paginacion.restriccionesDinamicas });
      setTimeout(() => {
        this.obtener_pagina_facturacion_usuarios();
      }, 0);
    }
  }


  validar_formulario_tipo_factura = (cfdi) => {
    const erroresRequeridos = {};
    if (!cfdi.tipoFactura)
      erroresRequeridos.tipoFactura = "El tipo de factura es requerido";
    if (!cfdi.fechaCreacion)
      erroresRequeridos.fechaCreacion = "La fecha inicial es requerida";
    if (!cfdi.fechaCertificacion)
      erroresRequeridos.fechaCertificacion = "La fecha final es requerida";
    return erroresRequeridos;
  }

  render() {
    let { rfcEmisor, paginacion, inicio, usuario, cfdi, erroresUsuarios, erroresUsuario,
      listaSeries, plazasCobro, ticket, listaAforos, listaMateriales } = this.state;

    const tipo_facturas = [
      { name: 'Factura de pagos', code: 0 },
      { name: 'Factura de emergencia', code: 1 },
      { name: 'Factura de Peaje', code: 2 },
      { name: 'Factura reexpedida', code: 3 },
      { name: 'Ingresos diversos', code: 4 },
      { name: 'Ingresos diversos/Nota de crédito', code: 5 },
      { name: 'Nota de crédito', code: 6 }
    ];

    return (
      <div>
        <Growl ref={(el) => this.growl = el} />
        <div className="card card-w-title" style={{ paddingBottom: '5px' }}>
          <h1>Consultas y Reportes</h1>
        </div>

        <div className="p-col-12" style={{ marginBottom: '60px' }}>
          <div className="card card-w-title" style={{ justifyContent: 'space-between' }}>
            <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.tab_panel(e)} >
              <TabPanel header="Usuarios Activos / Inactivos">
                <h2>Usuarios Activos / Inactivos con RFC de emisor: <strong>{rfcEmisor}</strong></h2>

                <h4 style={{ marginLeft: '5px' }}>Estatus:</h4>
                <div className="p-grid" style={{ alignItems: 'center', marginBottom: '20px' }}>
                  <div className="p-col-12 p-md-4" style={{ display: 'flex', justifyContent: 'center' }}>
                    <RadioButton value="1" inputId="rb1" name="usuario.estado" onChange={this.asignarValoresObjeto} checked={usuario.estado === "1"} />
                    <label htmlFor="rb1" className="p-radiobutton-label">Activo</label>
                    {erroresUsuarios.estado ? <div> <Message severity="error" text={erroresUsuarios.estado} /> </div> : null}
                  </div>
                  <div className="p-col-12 p-md-4" style={{ display: 'flex', justifyContent: 'center' }}>
                    <RadioButton value="0" inputId="rb2" name="usuario.estado" onChange={this.asignarValoresObjeto} checked={usuario.estado === "0"} />
                    <label htmlFor="rb2" className="p-radiobutton-label">Inactivo</label>
                    {erroresUsuarios.estado ? <div> <Message severity="error" text={erroresUsuarios.estado} /> </div> : null}
                  </div>
                  <div className="p-col-12 p-md-4">
                    <Button label="Buscar" onClick={this.buscar_usuarios_estado} style={{ width: '50%' }} />
                    {paginacion.datos.length > 0 ? <Button label="Descargar Excel" onClick={this.descargar_excel_usuario} className="p-button-warning" /> : ""}

                  </div>
                </div>
                <br />
                <DataTable value={paginacion.datos} header="LISTA DE USUARIOS" responsive={true}>
                  <Column style={{ textAlign: 'center' }} field="usuario" header="Usuario(Correo Electrónico)" sortable={true} />
                  <Column field="nombre" header="Nombre completo usuario" sortable={true} />
                </DataTable>
                <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiar_pagina} rowsPerPageOptions={[20, 40, 60, 80, 100]} ></Paginator>
              </TabPanel>

              <TabPanel header="Facturación">
                <TabView activeIndex={this.state.activeFacturacionIndex} onTabChange={(e) => this.tab_panel_facturacion(e)} >
                  <TabPanel header="Facturación por Usuario">
                    <h2>Facturación Por Usuario con RFC de emisor: <strong>{rfcEmisor}</strong></h2>
                    <div className="p-grid p-fluid">
                      <div className="p-col-12" style={{ heigh: '40px', marginTop: '10px' }}>
                        <div className="p-grid form-group" >

                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <InputText name="usuario.usuario" value={usuario.usuario || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.usuario ? 'p-error' : ''} />
                              <label>Nombre de Usuario (Correo Electrónico)</label>
                            </span>
                            {erroresUsuario.usuario ? <div> <Message severity="error" text={erroresUsuario.usuario} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <Calendar id="fechaCreacion" locale={servicioIdioma} name="cfdi.fechaCreacion" value={cfdi.fechaCreacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCreacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                              <label>Fecha inicio</label>
                            </span>
                            {erroresUsuario.fechaCreacion ? <div> <Message severity="error" text={erroresUsuario.fechaCreacion} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <Calendar id="fechaCertificacion" locale={servicioIdioma} name="cfdi.fechaCertificacion" value={cfdi.fechaCertificacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCertificacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                              <label>Fecha Final</label>
                            </span>
                            {erroresUsuario.fechaCertificacion ? <div> <Message severity="error" text={erroresUsuario.fechaCertificacion} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">

                          </div>
                          <div className="p-col-12 p-md-4">
                            {paginacion.datos.length > 0 ? <Button label="Descargar Excel" onClick={this.descargar_excel_facturacion_usuario} className="p-button-warning" /> : ""}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <Button label="Buscar" onClick={this.buscar_facturacion_usuario} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="Facturación Diaria">
                    <h2>Facturación Diaria con RFC de emisor: <strong>{rfcEmisor}</strong></h2>
                    <div className="p-grid p-fluid">
                      <div className="p-col-12" style={{ marginTop: '10px' }}>
                        <div className="p-grid form-group">
                          <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                              <Calendar id="fechaCreacion" locale={servicioIdioma} name="cfdi.fechaCreacion" value={cfdi.fechaCreacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCreacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                              <label>Fecha inicio</label>
                            </span>
                            {erroresUsuario.fechaCreacion ? <div> <Message severity="error" text={erroresUsuario.fechaCreacion} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                              <Calendar id="fechaCertificacion" locale={servicioIdioma} name="cfdi.fechaCertificacion" value={cfdi.fechaCertificacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCertificacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                              <label>Fecha Final</label>
                            </span>
                            {erroresUsuario.fechaCertificacion ? <div> <Message severity="error" text={erroresUsuario.fechaCertificacion} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">

                          </div>
                          <div className="p-col-12 p-md-4">
                            {paginacion.datos.length > 0 ? <Button label="Descargar Excel" onClick={this.descargar_excel_facturacion_diaria} className="p-button-warning" /> : ""}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <Button label="Buscar" onClick={this.buscar_facturacion_pordia} />
                          </div>
                        </div>
                      </div>
                    </div>


                  </TabPanel>
                  <TabPanel header="Facturación Mensual y/o Por Periodo">
                    <h2>Facturación Por Periodo con RFC de emisor: <strong>{rfcEmisor}</strong></h2>
                    <div className="p-grid p-fluid">
                      <div className="p-col-12" style={{ marginTop: '10px' }}>
                        <div className="p-grid form-group">
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <Dropdown name="cfdi.serie" options={listaSeries} value={cfdi.serie || ''} onChange={this.asignarValoresObjeto} placeholder="Serie" optionLabel="nombre" className={erroresUsuario.serie ? 'p-error' : ''} />
                            </span>
                            {erroresUsuario.serie ? <div> <Message severity="error" text={erroresUsuario.serie} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <Calendar id="fechaCreacion" locale={servicioIdioma} name="cfdi.fechaCreacion" value={cfdi.fechaCreacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCreacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                              <label>Fecha inicio</label>
                            </span>
                            {erroresUsuario.fechaCreacion ? <div> <Message severity="error" text={erroresUsuario.fechaCreacion} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <Calendar id="fechaCertificacion" locale={servicioIdioma} name="cfdi.fechaCertificacion" value={cfdi.fechaCertificacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCertificacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                              <label>Fecha Final</label>
                            </span>
                            {erroresUsuario.fechaCertificacion ? <div> <Message severity="error" text={erroresUsuario.fechaCertificacion} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">

                          </div>
                          <div className="p-col-12 p-md-4">
                            {paginacion.datos.length > 0 ? <Button label="Descargar Excel" onClick={this.descargar_excel_facturacion_serie_fecha} className="p-button-warning" /> : ""}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <Button label="Buscar R" onClick={this.buscar_facturacion_serie_fecha} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="Facturación Nota de Crédito Mes Anterior">
                    <h2>Facturación Por Nota de Crédito con RFC de emisor: <strong>{rfcEmisor}</strong></h2>
                    <div className="p-grid p-fluid">
                      <div className="p-col-12" style={{ marginTop: '10px' }}>
                        <div className="p-grid form-group">
                          <div className="p-col-12 p-md-4">

                          </div>
                          <div className="p-col-12 p-md-4">
                            {paginacion.datos.length > 0 ? <Button label="Descargar Excel" onClick={this.descargar_excel_facturacion_mes} className="p-button-warning" /> : ""}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <Button label="Buscar" onClick={this.buscar_facturacion_mes} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="RFC Receptor">
                    <h2>Consulta RFC receptor con RFC de emisor: <strong>{rfcEmisor}</strong></h2>
                    <div className="p-grid p-fluid">
                      <div className="p-col-12" style={{ marginTop: '10px' }}>
                        <div className="p-grid form-group">
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <InputText name="cfdi.rfcReceptor" value={cfdi.rfcReceptor || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.rfcReceptor ? 'p-error' : ''} />
                              <label>RFC Receptor</label>
                            </span>
                            {erroresUsuario.rfcReceptor ? <div> <Message severity="error" text={erroresUsuario.rfcReceptor} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <Calendar id="fechaCreacion" locale={servicioIdioma} name="cfdi.fechaCreacion" value={cfdi.fechaCreacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCreacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                              <label>Fecha inicio</label>
                            </span>
                            {erroresUsuario.fechaCreacion ? <div> <Message severity="error" text={erroresUsuario.fechaCreacion} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <Calendar id="fechaCertificacion" locale={servicioIdioma} name="cfdi.fechaCertificacion" value={cfdi.fechaCertificacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCertificacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                              <label>Fecha Final</label>
                            </span>
                            {erroresUsuario.fechaCertificacion ? <div> <Message severity="error" text={erroresUsuario.fechaCertificacion} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">

                          </div>
                          <div className="p-col-12 p-md-4">
                            {paginacion.datos.length > 0 ? <Button label="Descargar Excel" onClick={this.descargar_excel_facturacion_rfc_receptor} className="p-button-warning" /> : ""}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <Button label="Buscar" onClick={this.buscar_facturacion_rfc_receptor} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="Ingresos Diversos">
                    <h2>Consulta facturas ingresos diversos con RFC de emisor: <strong>{rfcEmisor}</strong></h2>
                    <div className="p-grid p-fluid">
                      <div className="p-col-12" style={{ marginTop: '10px' }}>
                        <div className="p-grid form-group">
                          <div className="p-col-12">
                            <span className="md-inputfield">
                              <Dropdown name="cfdi.ingresodiverso" options={listaMateriales} value={cfdi.ingresodiverso || ''} onChange={this.asignarValoresObjeto} placeholder="Concepto ingresos diversos" optionLabel="descripcion" className={erroresUsuario.ingresodiverso ? 'p-error' : ''} />
                            </span>
                            {erroresUsuario.ingresodiverso ? <div> <Message severity="error" text={erroresUsuario.ingresodiverso} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">

                          </div>
                          <div className="p-col-12 p-md-4">
                            {/*paginacion.datos.length > 0 ? <Button label="Descargar Excel" className="p-button-warning" /> : ""*/}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <Button label="Buscar" onClick={this.buscar_facturacion_ingresos_diversos} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel header="Tipo de Factura">
                    <h2>Reporte por Tipo de Factura con RFC de emisor: <strong>{rfcEmisor}</strong></h2>
                    <div className="p-grid p-fluid">
                      <div className="p-col-12" style={{ marginTop: '10px' }}>
                        <div className="p-grid form-group">
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <Dropdown name="cfdi.tipoFactura" options={tipo_facturas} value={cfdi.tipoFactura || ''} onChange={this.asignarValoresObjeto} placeholder="Tipo de Factura" optionLabel="name" className={erroresUsuario.tipoFactura ? 'p-error' : ''} />
                            </span>
                            {erroresUsuario.tipoFactura ? <div> <Message severity="error" text={erroresUsuario.tipoFactura} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <Calendar id="fechaCreacion" locale={servicioIdioma} name="cfdi.fechaCreacion" value={cfdi.fechaCreacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCreacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                              <label>Fecha inicio</label>
                            </span>
                            {erroresUsuario.fechaCreacion ? <div> <Message severity="error" text={erroresUsuario.fechaCreacion} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <span className="md-inputfield">
                              <Calendar id="fechaCertificacion" locale={servicioIdioma} name="cfdi.fechaCertificacion" value={cfdi.fechaCertificacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCertificacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                              <label>Fecha Final</label>
                            </span>
                            {erroresUsuario.fechaCertificacion ? <div> <Message severity="error" text={erroresUsuario.fechaCertificacion} /> </div> : null}
                          </div>
                          <div className="p-col-12 p-md-4">

                          </div>
                          <div className="p-col-12 p-md-4">
                            {paginacion.datos.length > 0 ? <Button label="Descargar Excel" onClick={this.descargar_excel_facturacion_tipo_factura} className="p-button-warning" /> : ""}
                          </div>
                          <div className="p-col-12 p-md-4">
                            <Button label="Buscar" onClick={this.buscar_facturacion_tipo_factura} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </TabView>
                <br />
                <DataTable value={paginacion.datos} header="CFDIS TIMBRADOS" scrollable={true} scrollHeight="280px" >
                  <Column field="ttCfdi.uuid" header="Folio Fiscal" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                  <Column field="ttCfdi.folio" header="Folio" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                  <Column field="ttCfdi.serie" header="Serie" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                  <Column body={this.columnaFechaCreacion} header="Fecha Creacion" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                  <Column field="tcEmisor.rfc" header="RFC Emisor" style={{ width: '200px', alignText: 'center' }} filter={false} autoLayout={true} />
                  <Column field="tcReceptor.rfc" header="RFC Receptor" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                  <Column body={this.columnaEstatus} header="Estado comprobante" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                  <Column body={this.columnaTipoFactura} header="Tipo Factura" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                  <Column body={this.columnaTotal} header="Total" style={{ width: '200px', alignText: 'center' }} filter={false} autoLayout={true} />
                  <Column body={this.columnaTipoComprobante} header="Tipo de Comprobante" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                </DataTable>
                <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiar_pagina_usuarios} rowsPerPageOptions={[20, 40, 60, 80, 100]} ></Paginator>


              </TabPanel>
              <TabPanel header="Aforo Ingreso">
                <h2>Aforo Ingreso con rfc de emisor: {rfcEmisor}</h2>
                <div className="p-grid p-fluid">
                  <div className="p-col-12" style={{ marginTop: '10px' }}>
                    <div className="p-grid form-group">
                      <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                          <Dropdown name="ticket.tcCarril" options={plazasCobro} value={ticket.tcCarril || ''} onChange={this.asignarValoresObjeto} placeholder="Plaza de Cobro" optionLabel="nombre" className={erroresUsuario.tcCarril ? 'p-error' : ''} />
                        </span>
                        {erroresUsuario.tcCarril ? <div> <Message severity="error" text={erroresUsuario.tcCarril} /> </div> : null}
                      </div>
                      <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                          <Calendar id="fechaFacturacion" locale={servicioIdioma} name="ticket.fechaFacturacion" value={ticket.fechaFacturacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaFacturacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                          <label>Fecha inicio</label>
                        </span>
                        {erroresUsuario.fechaFacturacion ? <div> <Message severity="error" text={erroresUsuario.fechaFacturacion} /> </div> : null}
                      </div>
                      <div className="p-col-12 p-md-4">

                      </div>
                      <div className="p-col-12 p-md-4">
                        {listaAforos.length > 0 ? <Button label="Descargar Excel" onClick={this.descargar_excel_facturacion_total_aforo} className="p-button-warning" /> : ""}
                      </div>
                      <div className="p-col-12 p-md-4">
                        <Button label="Buscar" onClick={this.buscar_reporte_aforo} />
                      </div>
                    </div>
                  </div>
                </div>

                <DataTable value={listaAforos} header="TOTAL DE AFOROS" scrollable={true} scrollHeight="280px" >
                  <Column field="tcCarril.tcPlazaCobro.nombre" header="Plaza de Cobro" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                  <Column body={this.columnaFechaTickets} header="Día" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                  <Column field="totalTickets" header="Total de Aforos" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                  <Column body={this.columnaSumaTickets} header="Precio Total" style={{ width: '200px', textAlign: 'center' }} filter={false} autoLayout={true} />
                </DataTable>

              </TabPanel>
              {/**  <TabPanel header="Tickets emergencia">
                <h1>Facturación Por Periodo con RFC de emisor: {rfcEmisor}</h1>
                <div className="p-grid p-fluid">
                  <div className="p-col-12">
                    <div className="p-grid form-group">
                      <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                          <Dropdown name="cfdi.emisor" options={tipo_facturas} value={cfdi.emisor || ''} onChange={this.asignarValoresObjeto} placeholder="Plaza de cobro" optionLabel="name" className={erroresUsuario.emisor ? 'p-error' : ''} />
                        </span>
                        {erroresUsuario.emisor ? <div> <Message severity="error" text={erroresUsuario.emisor} /> </div> : null}
                      </div>
                      <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                          <Calendar id="fechaCreacion" name="cfdi.fechaCreacion" value={cfdi.fechaCreacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCreacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                          <label>Fecha inicio</label>
                        </span>
                        {erroresUsuario.fechaCreacion ? <div> <Message severity="error" text={erroresUsuario.fechaCreacion} /> </div> : null}
                      </div>
                      <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                          <Calendar id="fechaCertificacion" name="cfdi.fechaCertificacion" value={cfdi.fechaCertificacion || ''} onChange={this.asignarValoresObjeto} className={erroresUsuario.fechaCertificacion ? 'p-error' : ''} dateFormat="yy-mm-dd" />
                          <label>Fecha Final</label>
                        </span>
                        {erroresUsuario.fechaCertificacion ? <div> <Message severity="error" text={erroresUsuario.fechaCertificacion} /> </div> : null}
                      </div>
                      <div className="p-col-12 p-md-4">

                      </div>
                      <div className="p-col-12 p-md-4">
                        {paginacion.datos.length > 0 ? <Button label="Descargar Excel" onClick={this.descargar_excel_facturacion_tipo_factura} className="p-button-warning" /> : ""}
                      </div>
                      <div className="p-col-12 p-md-4">
                        <Button label="Buscar" onClick={this.buscar_facturacion_tipo_factura} />
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>*/}
            </TabView>
          </div>
        </div>

      </div>
    );
  }

}